import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@jti/ui/components/Button";
export const CtaLink = ({ label, href, color, theme, ...restProps }) => (_jsx(Button, { ...restProps, href: href, variant: "cta", color: color || "primary", theme: theme, nativeBehaviour: true, children: label }));
//# sourceMappingURL=CtaLink.js.map